import React, { useEffect, useState } from 'react';
import { BedDouble, Users, CalendarCheck, DollarSign, Home, UserCheck } from 'lucide-react';
import api from '../services/api';

const StatCard = ({ icon: Icon, label, value, color }) => (
  <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="text-2xl font-bold text-gray-800 mt-1">{value}</p>
      </div>
      <div className={`p-3 rounded-full ${color}`}>
        <Icon size={22} className="text-white" />
      </div>
    </div>
  </div>
);

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/dashboard/stats').then(r => setStats(r.data)).catch(console.error);
  }, []);

  if (!stats) return <div className="flex items-center justify-center h-64 text-gray-400">Loading...</div>;

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-800 mb-6">Dashboard</h2>

      {/* Available Rooms — prominent hero card */}
      <div className="bg-forest-700 rounded-2xl p-6 mb-5 shadow-md flex items-center justify-between">
        <div>
          <p className="text-forest-200 text-sm font-medium uppercase tracking-wide">Available Rooms</p>
          <p className="text-white text-5xl font-bold mt-1">{stats.availableRooms}</p>
          <p className="text-forest-300 text-sm mt-1">of {stats.totalRooms} total rooms</p>
        </div>
        <div className="bg-forest-600 p-5 rounded-2xl">
          <Home size={36} className="text-forest-100" />
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <StatCard icon={BedDouble} label="Total Rooms"      value={stats.totalRooms}                                      color="bg-brand-500" />
        <StatCard icon={Users}     label="Occupied"          value={stats.occupiedRooms}                                   color="bg-orange-500" />
        <StatCard icon={CalendarCheck} label="Reserved"     value={stats.reservedRooms}                                   color="bg-blue-500" />
        <StatCard icon={UserCheck} label="Active Students"  value={stats.activeStudents}                                  color="bg-brand-400" />
        <StatCard icon={Users}     label="Total Students"   value={stats.totalStudents}                                   color="bg-brand-600" />
        <StatCard icon={CalendarCheck} label="Reservations" value={stats.totalReservations}                               color="bg-yellow-500" />
        <StatCard icon={DollarSign} label="Monthly Revenue" value={`Rs. ${stats.monthlyRevenue.toLocaleString()}`}        color="bg-forest-500" />
      </div>
    </div>
  );
}
